export default "__VITE_ASSET__CTKpDiDr__"